import type { SVGProps } from 'react';
const DawnFlagCU = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-CU_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-CU_svg__a)">
      <path fill="#0B389F" d="M0 3.2h22V0H0zM0 9.6h22V6.4H0zM0 16h22v-3.2H0z" />
      <path fill="#E12A43" d="m0 0 10.476 8L0 16z" />
      <path
        fill="#fff"
        d="m3.667 8.818-1.232.908.467-1.473-1.228-.912 1.52-.003.473-1.471.472 1.471 1.52.003-1.228.912.467 1.473z"
      />
    </g>
  </svg>
);
export default DawnFlagCU;
